import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { useSettings } from "../../context/SettingsContext";
import { Button } from "../Buttons/Button";
import LanguageSelector, {
  LanguageDropdownProps,
} from "../LanguageSelector/LanguageSelector";
import { postFlyoutToggleMessage } from "../../utils/message.helper";
import { FaArrowLeft, FaTimes } from "react-icons/fa";
interface HeaderProps {
  isFeedbackActive: boolean;
  setIsFeedbackActive: (active: boolean) => void;
  setIsFlyoutOpen: (open: boolean) => void;
  isLargeScreen: boolean;
  startDrag: (e: React.MouseEvent) => void;
  dropdownRef: React.RefObject<HTMLDivElement>;
  dropdownProps: Omit<LanguageDropdownProps, "className">;
}

const Header: React.FC<HeaderProps> = ({
  isFeedbackActive,
  setIsFeedbackActive,
  setIsFlyoutOpen,
  isLargeScreen,
  startDrag,
  dropdownRef,
  dropdownProps
}) => {
  const { t } = useTranslation();
  const { widgetDataSettings, oversizeWidget } = useSettings();

  return (
    <div
      style={{
        background: widgetDataSettings?.settings?.appearance?.colors
          ?.buttonColor
          ? widgetDataSettings.settings.appearance.colors.buttonGradientEnabled
            ? `linear-gradient(${widgetDataSettings.settings.appearance.colors.buttonColorGradient}, ${widgetDataSettings.settings.appearance.colors.buttonColor})`
            : widgetDataSettings.settings.appearance.colors.buttonColor
          : "#0048FF",
        height: "32px",
        cursor: "grab",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingTop: "20px",
        paddingBottom: "20px",
        paddingLeft: "16px",
        paddingRight: "16px",
        borderTopLeftRadius: isLargeScreen ? "8px" : "0px",
        borderTopRightRadius: isLargeScreen ? "8px" : "0px",
        borderBottomLeftRadius: "0px",
        borderBottomRightRadius: "0px",
      }}
      onMouseDown={startDrag}
    >
      <div className="flex items-center">
        {/* Show Close Button only when accessibility menu is displayed */}
        {!isFeedbackActive && (
          <Button
            icon={() => (
              <FaTimes className="w-4 h-4" />
            )}
            style={{
              backgroundColor:
                widgetDataSettings?.settings?.appearance?.colors
                  ?.buttonColor || "#0048FF",
            }}
            className="text-white w-6 h-6 rounded-full flex items-center justify-center border border-white"
            onClick={() => {
              setIsFlyoutOpen(false);
              postFlyoutToggleMessage(false);
            }}
          />
        )}

        {!isFeedbackActive ? (
          <span
            className={twMerge(
              clsx(
                "text-[16px] text-white ml-2",
                oversizeWidget ? "font-semibold" : undefined
              )
            )}
          >
            {t(
              isLargeScreen ? "accessibility_menu_(esc)" : "accessibility_menu"
            )}
          </span>
        ) : (
          <div
            className="flex items-center cursor-pointer"
            onClick={() => setIsFeedbackActive(false)}
          >
            <Button
              icon={() => (
                <FaArrowLeft className="w-4 h-4" />
              )}
              style={{
                backgroundColor:
                  widgetDataSettings?.settings?.appearance?.colors
                    ?.buttonColor || "#0048FF",
              }}
              className="text-white w-6 h-6 rounded-full flex items-center justify-center border border-white"
            />
            <span
              className={twMerge(
                clsx(
                  "text-sm text-white pl-1",
                  oversizeWidget ? "font-semibold" : undefined
                )
              )}
            >
              {t("accessibility_statement_and_send_feedback")}
            </span>
          </div>
        )}
      </div>

      <div ref={dropdownRef}>
        <LanguageSelector ref={dropdownRef} {...dropdownProps} />
      </div>
    </div>
  );
};

export default Header;
